
import 'pages/products/parameters/parameters-groups-list.tag'
import 'pages/products/parameters/parameters-list.tag'
riot.tag2('parameters', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="active"><a data-toggle="tab" href="#palametrs-list">Список параметров</a></li>\n    <li><a data-toggle="tab" href="#parameters-groups">Категории</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="palametrs-list">\n      <parameters-list></parameters-list>\n    </div>\n    <div class="tab-pane fade" id="parameters-groups">\n      <parameters-groups-list></parameters-groups-list>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create();
self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/products/parameters/parameters.tag